// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"ad766ddb","388":"ad766ddb"}[chunkId] + ".chunk.css";
};